import { Flex, FlexProps } from '@modusign/design-system';

import BodyOverflowHiddenPositionFixed from '@app/components/BodyOverflowHiddenPositionFixed';

interface PDFDocumentPageLayoutProps extends FlexProps<'div'> {}

const PDFDocumentPageLayout = (props: PDFDocumentPageLayoutProps) => {
  return (
    <>
      <BodyOverflowHiddenPositionFixed />
      {/* TODO (#4375): 레이아웃 시스템 변경 논의/변경 필요 */}
      <Flex bg="#484848" {...props} flexDirection="column" height="100%" />
    </>
  );
};

export default PDFDocumentPageLayout;
